import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FaTriangleExclamation } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { openChat } from "../../redux/action/member/memberAction";
import { useLocation } from "react-router-dom";

const FreezeWrapper = ({ children, className }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`profile.${key}`);
  const i18n_gamebox = (key) => t(`gamebox.${key}`);
  const i18n_common = (key) => t(`common.${key}`);

  const location = useLocation();

  const isGameBox = useMemo(() => {
    return location.pathname.includes("gamebox");
  }, [location.pathname]);

  const memberData = useSelector((state) => state.isMemberInfo);
  const dispatch = useDispatch();

  const textColor = useColorModeValue("dark.100", "light.100");

  const { status } = memberData || {};

  return (
    <>
      {status == 2 || status == 4 ? (
        <Alert
          {...className}
          position={"absolute"}
          bg={isGameBox ? "rgba(0,0,0,0.1)" : "#33414B"}
          top="0"
          left="0"
          w="100%"
          h="100%"
          zIndex={999}
          status="info"
          variant="subtle"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
        >
          <AlertIcon boxSize="40px" mr={0} />
          <AlertTitle color={textColor} mt={4} mb={1} fontSize="lg">
            {i18n_common("notice_you")}!!
          </AlertTitle>
          <AlertDescription fontSize="xl" color={textColor} maxWidth="sm">
            {status == 4 ? i18n("4_freezeHint") : i18n("freezeHint")}
          </AlertDescription>
          <Button
            mt="15px"
            type="button"
            variant={`brandPrimary`}
            onClick={() => {
              dispatch(openChat());
            }}
            size="md"
            fontWeight={`medium`}
          >
            {i18n_gamebox("contactCustomerServiceNow")}
          </Button>
        </Alert>
      ) : null}
      {children}
    </>
  );
};

export default FreezeWrapper;
